// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"217bcaa4","126":"84cebdc7","255":"72e67d01","264":"08e4491e","292":"a91d9c99","453":"23bc37c1","671":"f5c68d7e","809":"bde8f7ca"}[chunkId] + ".chunk.js";
};